var _path, _path2, _path3, _path4, _path5, _g, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSk24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.22952 15.9348C3.62004 15.6484 3.1177 15.417 3.1177 14.9505C3.1177 14.5936 3.4037 14.3341 3.96633 14.3341C4.17289 14.3341 4.344 14.3565 4.51919 14.3899C4.61044 14.405 4.70904 14.4188 4.7897 14.4188C5.28145 14.4188 5.5593 14.1259 5.74385 13.5681L5.82045 13.3392C5.74182 13.3078 4.93759 12.9546 3.88852 12.9546C2.221 12.9546 1.33937 14.0253 1.34059 15.1375C1.34059 15.6973 1.51619 16.1047 1.79078 16.4241C2.14563 16.836 2.64919 17.1061 3.12015 17.3354C3.80704 17.6736 4.42752 17.9229 4.42752 18.4232C4.42752 18.8673 3.96919 19.1207 3.35522 19.1207C2.51719 19.1207 1.78344 18.64 1.69056 18.5817L1 19.876C1.12222 19.9453 2.00956 20.51 3.47296 20.51C5.02885 20.5096 6.20707 19.6145 6.20707 18.2387C6.20707 16.8714 5.11441 16.3634 4.22952 15.9348Z",
    fill: "#E21837"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3187 16.5724L13.1432 13.105H11.131L8.87889 16.0982H8.84508V13.105H7.18652V20.4505H7.28512C8.00175 20.4505 8.85567 20.1181 8.85567 18.9199V17.2324H8.89071L11.1864 20.3601H13.2964L10.3187 16.5724Z",
    fill: "#E21837"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2375 5.23633C12.6524 5.34633 11.7867 5.87637 11.79 6.81707C11.7916 7.66855 12.4887 8.18474 12.4907 9.30185C12.4935 10.1427 12.0315 10.7086 11.5312 11.0223C11.7333 11.0036 11.9554 10.9922 12.1982 10.9922C12.7099 10.9906 13.0171 11.039 13.0362 11.0431L15.6562 7.82255C14.9278 6.73192 14.078 5.88574 13.2375 5.23633Z",
    fill: "#E21837"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4382 13.9293C15.7674 13.4168 15.8102 12.5967 15.8375 11.7619C15.8685 10.9842 16.0306 10.3979 17.0703 10.3938C17.3005 10.3926 17.5209 10.4252 17.9185 10.424C19.4418 10.4175 20.4355 9.89149 21.0548 9.54723C19.7906 8.74056 17.9446 7.91556 15.6562 7.82227C15.5075 8.24556 14.3472 11.4747 14.2588 11.735C14.273 11.7509 14.4759 11.979 14.7298 12.4239C15.1042 13.0346 15.3042 13.552 15.4382 13.9293Z",
    fill: "#E21837"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3925_20250",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 3,
    width: 5,
    height: 9
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.87207 3.31201H12.8671V11.2913H8.87207V3.31201Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3925_20250)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90405 11.2915C9.77286 11.2915 9.70686 11.2039 9.68934 11.0519C9.67264 10.8992 9.01671 4.89846 8.91893 3.98872C8.90508 3.85549 8.87208 3.61227 8.87208 3.52509C8.87086 3.38494 8.96253 3.31201 9.07049 3.31201C9.38053 3.3112 11.0713 3.70842 12.8671 4.96812C12.3501 5.11357 11.4135 5.65298 11.4176 6.76927C11.422 7.7552 12.1273 8.29909 12.1313 9.29112C12.1362 10.9012 10.2886 11.2907 9.90405 11.2915Z",
    fill: "#F37725"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5884 14.3564C15.6165 14.4325 15.643 14.4965 15.6703 14.5397C15.711 14.611 15.7644 14.6428 15.832 14.6428C15.8732 14.6428 15.9241 14.6269 15.9807 14.6012C16.1192 14.5377 21.5895 11.9881 22.4145 11.6068C22.5355 11.5497 22.7608 11.4483 22.8374 11.4043C22.9136 11.3603 22.9486 11.2947 22.9486 11.2291C22.9486 11.1928 22.9376 11.1558 22.918 11.1215C22.8154 10.9549 22.2845 10.3927 21.3992 9.77832C20.6969 10.1645 19.5997 10.7647 17.9672 10.7708C17.5663 10.7716 17.4771 10.7431 17.2042 10.7459C16.4073 10.7484 16.2089 11.0885 16.1787 11.7885C16.1738 11.9205 16.1734 12.0981 16.164 12.2937C16.1392 12.9198 16.0659 13.7811 15.5884 14.3564Z",
    fill: "#F37725"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSk24);
export default __webpack_public_path__ + "static/media/SK증권-24.4d79ffdccdbf4060d59fb7b175e9fec5.svg";
export { ForwardRef as ReactComponent };